import { PublishExDoDef } from "../../type/report/publish-ex-do";

export class PublishExDoAdapter {
  static toInputDTO(): any {
    return {
    };
  }

  static toOutputDTO(res: any): PublishExDoDef {
    return res;
  }
}
